module.exports = __webpack_public_path__ + "img/Emir-Pretnar.e9d9045b.jpg";